export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/report_stars_icon.d1eb2a32.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};